import React from 'react';
import Navbar from '../components/Navbar';
import EducationHero from '../components/education/EducationHero';
import EducationProblem from '../components/education/EducationProblem';
import WhyTraainEducation from '../components/education/WhyTraainEducation';
import TrainingIntelligenceEducation from '../components/education/TrainingIntelligenceEducation';
import RolePlayIntelligenceEducation from '../components/education/RolePlayIntelligenceEducation';
import ExchangeEducation from '../components/education/ExchangeEducation';
import EducationKPIs from '../components/education/EducationKPIs';
import EducationCTA from '../components/education/EducationCTA';
import Footer from '../components/Footer';

const EducationPage = () => {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      {/* Animated Background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-950 via-gray-900 to-purple-950 animate-gradient" />
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl animate-blob" />
          <div className="absolute top-0 right-0 w-96 h-96 bg-purple-500 rounded-full filter blur-3xl animate-blob animation-delay-2000" />
          <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl animate-blob animation-delay-4000" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Navbar />
        <EducationHero />
        <EducationProblem />
        <WhyTraainEducation />
        <TrainingIntelligenceEducation />
        <RolePlayIntelligenceEducation />
        <ExchangeEducation />
        <EducationKPIs />
        <EducationCTA />
        <Footer />
      </div>
    </div>
  );
};

export default EducationPage;
